const FormResources = {

    form_format:[
        {
            css_class:  'col-md-3',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'current_date',
            ref:        'current_date_input',
            ref_alt:    'current_date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'supervisor_id',
            ref:        'supervisor_id_input',
            ref_alt:    'supervisor_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   false,
        },
    ],
    shifts:
    [
        {
            id: 1,
            name: 'All Day Assignments'
        },
        {
            id: 2,
            name: 'All Evening Assignments'
        },
        {
            id: 3,
            name: 'All Night Assignments'
        }

    ]

}

export default FormResources;